package com.iptvplayer.shared.data.local.db

import app.cash.sqldelight.db.SqlDriver

actual class DatabaseDriverFactory {
    actual fun createDriver(): SqlDriver {
        // For web, we use a simple in-memory approach
        // In production, consider using sql.js or IndexedDB
        throw UnsupportedOperationException("SQLDelight not supported on JS target. Use in-memory caching.")
    }
}
